export const SYS_ADMIN_ROLE = 0;
export const ADMIN_ROLE = 1;
export const AGENT_ROLE = 2;
export const GUEST_ROLE = 4;
